import styled from "styled-components";
import Logo01 from "@public/assets/service/PC_05_01.png"
import Logo02 from "@public/assets/service/PC_05_02.png"
import Logo03 from "@public/assets/service/PC_05_03.png"
import Logo04 from "@public/assets/service/PC_05_04.png"
import Logo05 from "@public/assets/service/PC_05_05.png"
import Logo06 from "@public/assets/service/PC_05_06.png"
import Logo07 from "@public/assets/service/PC_05_07.png"
import Logo08 from "@public/assets/service/PC_05_08.png"
import Logo09 from "@public/assets/service/PC_05_09.png"
import {SIZES} from "@/components/constants";
import {useRouter} from "@/i18n/navigation";
import {useSectionActive} from "@/app/[locale]/services/useSectionActive";
import ContentSlidWrap from "@/app/[locale]/services/components/ContentSlidWrap";
import {useMediaQuery} from "react-responsive";



const AllianceSection = ({ data, index, activeIndex }) => {
    const router = useRouter();
    const isTablet = useMediaQuery(
        { query: `(max-width: ${SIZES.TABLET})` },
        undefined,
        () => false
    );
    const sectionActive = index <= activeIndex;
    const titleRef = useSectionActive(sectionActive);
    const contentRef = useSectionActive(sectionActive);
    const btnRef = useSectionActive(sectionActive);
    return(
        <SectionWrap>
            <div className={"container"}>
                <div className={"title-wrap"} ref={titleRef}>
                    <div
                        className={"title-pc"}
                        dangerouslySetInnerHTML={{__html: data["pc-partnership-title"]}}
                    />
                    <div
                        className={"title-tablet"}
                        dangerouslySetInnerHTML={{__html: data["tablet-partnership-title"]}}
                    />
                </div>
                <div className={"content-wrap"} ref={contentRef}>
                    {/*<ul className={"logo-grid"}>*/}
                    {/*    {LOGO_LIS.map((item, idx) => (*/}
                    {/*        <li key={idx} className={"logo-card"}>*/}
                    {/*        <img src={item.image} alt={`${idx + 1} 번째 로고`}/>*/}
                    {/*        </li>*/}
                    {/*    ))}*/}
                    {/*</ul>*/}
                    <div className={"hero-sec"}>
                        <ContentSlidWrap list={LOGO_LIS}/>
                        <div className={"alliance-text"}>
                            <p dangerouslySetInnerHTML={{__html: data["partnership-text1"]}}/>
                            <p dangerouslySetInnerHTML={{__html: data["partnership-text2"]}}/>
                            <p dangerouslySetInnerHTML={{__html: data["partnership-text3"]}}/>
                        </div>
                        <ul className={"alliance-pill-list"}>
                            <li className={"alliance-pill"} dangerouslySetInnerHTML={{__html: data["partnership-text4"]}}/>
                            <li className={"alliance-pill"} dangerouslySetInnerHTML={{__html: data["partnership-text5"]}}/>
                            <li className={"alliance-pill"} dangerouslySetInnerHTML={{__html: data["partnership-text6"]}}/>
                            <li className={"alliance-pill"} dangerouslySetInnerHTML={{__html: data["partnership-text7"]}}/>
                        </ul>
                    </div>
                    <div className={"alliance-cta"}>
                        <div className={"alliance-btn-inner"} onClick={() => router.push("/help-center")}>
                            <p dangerouslySetInnerHTML={{__html: data["partnership-inquiry"]}}/>
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrap>
    )
}
const SectionWrap = styled.section`
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    gap: 120px;
    
    .title-wrap,
    .content-wrap {
        opacity: 0;
        transform: translateY(60px);
        transition: all 0.6s ease;
    }

    .title-wrap.is-show,
    .content-wrap.is-show {
        opacity: 1;
        transform: translateY(0);
    }
    .container {
        padding: 0 24px;
        width: 100%;
        margin: 0 auto;

        .title-pc {
            display: none;
            line-height: 0;
            font-size: 40px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 64px;
            p{
                line-height: 1.6;
                span{
                    color: #07903a;
                }
            }
        }
        .title-tablet{
            display: block;
            line-height: 0;
            font-size: 18px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 32px;
            p{
                line-height: 1.6;
                span{
                    color: #07903a;
                }
            }
        }
        .content-wrap{
            .logo-grid{
                display: grid;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                gap: 8px;
                .logo-card{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #ffffff;
                    border-radius: 6px;
                    border: 1px solid #f1f3f5;
                    height: 80px;
                    img {
                        max-width: 80%;
                        max-height: 36px;
                        width: auto;
                        height: auto;
                        object-fit: contain;
                    }
                }
            }
            .alliance-text{
                text-align: center;
                margin-top: 40px;
                p{
                    color: #0f172a;
                    line-height: 1.625;
                    font-weight: 700;
                    font-size: 28px;
                }
            }
            .alliance-pill-list{
                gap: 16px;
                justify-content: center;
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                margin-top: 32px;
                .alliance-pill{
                    background-color: #ffffff;
                    border-radius: 999px;
                    padding: 16px 40px;
                    font-size: 18px;
                    color: #5F5D67;
                    text-align: center;
                    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
                    line-height: 1.5;
                }
            }
            .alliance-cta{
                margin-top: 80px;
                text-align: center;
                .alliance-btn-inner{
                    min-width: 260px;
                    background: #07903A;
                    font-size: 14px;
                    line-height: 20px;
                    font-weight: 600;
                    color: #fff;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 16px;
                    padding: 20px 0;
                    cursor: pointer;
                }
            }
        }
    }
    
    @media (max-width: ${SIZES.MOBILE}) {
        .container{
            .content-wrap{
                .logo-grid{
                    .logo-card{
                        height: 72px;
                    }
                }
                .alliance-text{
                    p{
                        font-size: 14px;
                    }
                }
                .alliance-pill-list{
                    .alliance-pill{
                        padding: 12px 18px;
                        font-size: 13px;
                        white-space: normal;
                        display: block;
                        width: 100%;
                    }
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .container{
            .content-wrap{
                .alliance-pill-list {
                    grid-template-columns: 1fr;
                    justify-items: center;
                }
            }
        }
    }
    @media screen and (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .content-wrap{
                .logo-grid{
                    gap: 24px;
                }
            }
        }
    }
    @media screen and (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;
            .content-wrap{
                .alliance-pill-list{
                    gap: 20px;
                    margin-top: 40px;
                }
                .alliance-cta{
                    .alliance-btn-inner{
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }
    }
    @media screen and (min-width: ${SIZES.TABLET}) {
        gap: 133px;
        .container {
            padding: 0 40px;
            max-width: 1024px;
            .title-pc{
                display: block;
            }
            .title-tablet{
                display: none;
            }
            .content-wrap{
                .logo-grid{
                }
            }
        }
    }
    @media screen and (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;

        }
    }
    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;

        }
    }
`
const LOGO_LIS = [
    {image: Logo01?.src},
    {image: Logo02?.src},
    {image: Logo03?.src},
    {image: Logo04?.src},
    {image: Logo05?.src},
    {image: Logo06?.src},
    {image: Logo07?.src},
    {image: Logo08?.src},
    {image: Logo09?.src},
]
export default AllianceSection;